export default class RoadStatuses {
  static async getRoadStatuses(filters = {}) {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.region) params.append('region', filters.region);
    if (filters.road_type) params.append('road_type', filters.road_type);
    if (filters.agency_type) params.append('agency_type', filters.agency_type);
    if (filters.status_source_method) params.append('status_source_method', filters.status_source_method);
    if (filters.search) params.append('search', filters.search);

    const query = params.toString();
    const url = `/road_statuses${query ? '?' + query : ''}`;

    return new Promise((resolve, reject) => {
      return fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" }
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  static async getRoadChanges(roadId) {
    return new Promise((resolve, reject) => {
      return fetch(`/road_statuses/${roadId}/changes`, {
        method: "GET",
        headers: { Accept: "application/json" }
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  static async getPipelineHealth() {
    return new Promise((resolve, reject) => {
      return fetch(`/road_pipeline_health`, {
        method: "GET",
        headers: { Accept: "application/json" }
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  static async runPipeline() {
    return new Promise((resolve, reject) => {
      return fetch(`/road_pipeline_run`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }
}
